"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modalConfig = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
exports.modalConfig = [
    {
        name: apps_shared_1.POPUP_CONSTANTS.SIGN_UP_MODAL,
        enabled: true,
        priority: 10,
        settings: null,
    },
    {
        name: apps_shared_1.POPUP_CONSTANTS.SIGN_IN_MODAL,
        enabled: true,
        priority: 10,
        settings: null,
    },
    {
        name: apps_shared_1.POPUP_CONSTANTS.DAILY_DIGEST,
        enabled: true,
        priority: 5,
        settings: null,
    },
    {
        name: apps_shared_1.POPUP_CONSTANTS.DEPOSIT,
        enabled: true,
        priority: 30,
        settings: null,
    },
    // { name: WELCOME_BANNER, enabled: true, priority: 10, settings: null },
    {
        name: apps_shared_1.POPUP_CONSTANTS.LEVEL_UP,
        enabled: true,
        priority: 100,
        settings: null,
    },
    // { name: LIMITS, enabled: true, priority: 50, settings: null },
    // { name: FREESPINS_LEFT, enabled: true, priority: 50, settings: null },
    {
        name: apps_shared_1.POPUP_CONSTANTS.CASH_BONUS,
        enabled: true,
        priority: 60,
        settings: null,
    },
    // { name: BONUS_PLAY, enabled: true, priority: 30, settings: null },
];
